import { render, staticRenderFns } from "./TravelAddressEditComponent.vue?vue&type=template&id=a6855e78"
import script from "./TravelAddressEditComponent.vue?vue&type=script&lang=js"
export * from "./TravelAddressEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports